import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./index.css";

// Import pages

import BlissSierra from "./BlissSierra";
import Services from "./Services";
import Careers from "./Careers";
import OurTeam from "./OurTeam";
import ScrollToTop from "./ScrollToTop";
import TungaDrones from "./TungaDrones";
import OurProjects from "./OurProjects";



const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(

  <BrowserRouter>
  <ScrollToTop/>
    <Routes>
      <Route path="/" element={<BlissSierra />} />

      <Route path="/Services" element={<Services />} />

      <Route path="/Careers" element={<Careers/>} /> 

      <Route path="/OurTeam" element={<OurTeam/>} /> 

      <Route path="/Tunga-Drones" element={<TungaDrones />} />

      <Route path="/Our-Projects" element={<OurProjects />} />

    </Routes>
  </BrowserRouter>

);
